// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LaudoPublico_GetPublicResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /laudo_links/publico/{token}
 *
 * Public read-only view of a laudo (entrada OR saida), resolved by token.
 * No authentication — the unguessable UUIDv7 token IS the authorization.
 *
 * The attribute definitions + values reuse the SAME row contracts as
 * GET /so/orders/atributos_laudo/{id}/{type}, so the public page feeds
 * them straight into SOReportAttributesList (editable=false), merging
 * definitions <-> values exactly like the private laudo pages do.
 * Photos are value rows whose so_ra_type === 'photo' and so_rav_value
 * holds the image URL (or data URI).
 */
import type { Orders_LaudoAttributeDefinitionRow } from './Orders_LaudoAttributeDefinitionRow'
import type { Orders_LaudoAttributeValueRow } from './Orders_LaudoAttributeValueRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface LaudoPublico_GetPublicResponseDados {
definitions: Orders_LaudoAttributeDefinitionRow[]
values: Orders_LaudoAttributeValueRow[]
is_valid?: boolean
error_message?: string
tipo?: string
order_item_id?: number
item_descricao?: string
item_qrcode?: string
order_id?: number
franquia_id?: number
franquia_nome?: string
cliente_nome?: string
status?: string
final_status?: string
observations?: string
}

export type LaudoPublico_GetPublicResponse = ApiResponse<LaudoPublico_GetPublicResponseDados>;

registerResponseContract('LaudoPublico_GetPublicResponse', {
  definitions: {
    type: 'array',
    required: true,
    items: {
      so_cra_id:            { type: 'number',  required: true },
      so_cra_category_id:   { type: 'number',  required: true },
      so_cra_attribute_id:  { type: 'number',  required: true },
      so_cra_required:      { type: 'number',  required: true },
      so_cra_display_order: { type: 'number',  required: true },
      so_cra_report_type:   { type: 'string',  required: true },
      so_cra_created_at:    { type: 'string',  required: true },
      so_ra_id:             { type: 'number',  required: true },
      so_ra_name:           { type: 'string',  required: true },
      so_ra_type:           { type: 'string',  required: true },
      so_ra_options: {
        type: 'array',
        required: false,
        items: {
          ID:   { type: 'string',  required: true },
          Name: { type: 'string',  required: true },
        },
      },
    },
  },
  values: {
    type: 'array',
    required: true,
    items: {
      so_rav_id:           { type: 'number',  required: true },
      so_rav_report_id:    { type: 'number',  required: true },
      so_rav_report_type:  { type: 'string',  required: true },
      so_rav_attribute_id: { type: 'number',  required: true },
      so_rav_value:        { type: 'string',  required: false },
      so_rav_created_at:   { type: 'string',  required: true },
      so_ra_name:          { type: 'string',  required: true },
      so_ra_type:          { type: 'string',  required: true },
    },
  },
  is_valid:       { type: 'boolean', required: false },
  error_message:  { type: 'string',  required: false },
  tipo:           { type: 'string',  required: false },
  order_item_id:  { type: 'number',  required: false },
  item_descricao: { type: 'string',  required: false },
  item_qrcode:    { type: 'string',  required: false },
  order_id:       { type: 'number',  required: false },
  franquia_id:    { type: 'number',  required: false },
  franquia_nome:  { type: 'string',  required: false },
  cliente_nome:   { type: 'string',  required: false },
  status:         { type: 'string',  required: false },
  final_status:   { type: 'string',  required: false },
  observations:   { type: 'string',  required: false },
})
